import { render, staticRenderFns } from "./UninstallThankYou.vue?vue&type=template&id=55623cee&scoped=true&"
import script from "./UninstallThankYou.vue?vue&type=script&lang=js&"
export * from "./UninstallThankYou.vue?vue&type=script&lang=js&"
import style0 from "./UninstallThankYou.vue?vue&type=style&index=0&id=55623cee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55623cee",
  null
  
)

export default component.exports